export default  {
    getAll,
}

async function getAll() {
    return new Promise(async (resolve, reject) => {
        try {
            fetch('/api/users?limit=1000', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('DANESH_FX_ADMIN_TOKEN')
                },
            }).then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok')
                }
                resolve(response.json())

            }).catch(error => {
                // Handle error
                console.error('There was a problem updating the cashback submission:', error)
            })
        } catch (error) {
            reject(error)
        }
    })
}